import { InputGroupAddon, InputGroupInput } from '@playbooks/ui/components/input-group'
import { InputProps } from '../types'
import InputGroupWrapper from '../../../components/ui/InputGroupeWrapper'
import { Calendar } from 'lucide-react'
import { parseDate } from '../../../utils/utils'
import formatForDatetimeInput from '../../../utils/formatForDatetimeInput'

export default function DatePicker({
  question,
  onChange,
  invalid,
  type,
}: { type: 'date' | 'datetime-local' } & InputProps) {
  const value = (
    type === 'datetime-local'
      ? // DateTime value is stored as UTC string,
        // but the input expects value in wall-clock format (YYYY-MM-DDTHH:MM)
        formatForDatetimeInput(question.value as string)
      : question.value
  ) as string

  return (
    <InputGroupWrapper className="relative flex items-center">
      <InputGroupInput
        id={`question-${question.id}`}
        type={type}
        // The operator `??` prevents uncontrolled to controlled input warning
        value={value ?? ''}
        onChange={e => {
          onChange(
            type === 'datetime-local'
              ? // DateTime value should be stored as UTC string,
                // but the input provides the value in wall-clock format (YYYY-MM-DDTHH:MM)
                parseDate(e.target.value)?.toISOString()
              : e.target.value,
          )
        }}
        aria-invalid={invalid}
        required={question.required}
        className="[&::-webkit-calendar-picker-indicator]:opacity-0"
      />
      <InputGroupAddon className="absolute right-3 top-0.5 text-foreground pointer-events-none">
        <Calendar />
      </InputGroupAddon>
    </InputGroupWrapper>
  )
}
